<template>
    <PageLayout :title="$t('profile')" v-if="authUser">
        <v-row>
            <v-col align="center" justify="center" class="heading py-0">
                <v-btn-toggle
                    v-model="tab"
                    background-color="#ffffff"
                    active-class="nav-button--active"
                    color="blue"
                    dense
                    mandatory
                    style="width: 100%;"
                >
                    <v-btn
                        small
                        style="border-color: #2f80ed !important; width: 50%;"
                        class="nav-button"
                    >
                        {{ $t("credit_score.score") }}
                    </v-btn>
                    <v-btn
                        small
                        style="border-color: #2f80ed !important; width: 50%;"
                        class="nav-button"
                    >
                        {{ $t("personal_data") }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="center" justify="center" class="pa-0">
                <v-tabs-items v-model="tab" class="px-4">
                    <v-tab-item key="0">
                        <v-row justify="center">
                            <v-col class="pt-0" cols="12" lg="12" xl="10">
                                <CreditScoreTemplate></CreditScoreTemplate>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item key="1">
                        <PersonalInformation></PersonalInformation>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>

        <ValidatePhone></ValidatePhone>
        <VerificateEmailModal :user="authUser" :closable="true"></VerificateEmailModal>
        <ChangePasswordModal></ChangePasswordModal>
        <PersonalDataModal></PersonalDataModal>
        <UserTermsModal></UserTermsModal>
    </PageLayout>
</template>

<script>
import CreditScoreTemplate from "../shared/components/creditScoreTemplate";
import PersonalOffersTemplate from "../shared/components/personalOffersTemplate";
import ChangePasswordModal from "@/app/mobile/profile/shared/modals/changePassword";
import VerificateEmailModal from "@/app/mobile/profile/shared/modals/verificateEmail";
import ValidatePhone from "@/app/mobile/registration/shared/components/ValidatePhone";

import PersonalDataModal from "@/app/mobile/registration/shared/modals/PersonalDataModal";
import UserTermsModal from "@/app/mobile/registration/shared/modals/UserTermsModal";

import PersonalInformation from "../shared/components/personalInformation";
import PageLayout from "@/app/mobile/ui/PageLayout";

export default {
    $_veeValidate: {
        validator: "new",
    },
    name: "Profile",
    components: {
        ValidatePhone,
        VerificateEmailModal,
        ChangePasswordModal,
        CreditScoreTemplate,
        PersonalDataModal,
        UserTermsModal,
        PersonalOffersTemplate,
        PersonalInformation,
        PageLayout,
    },
    data() {
        return {
            tab: 0,
        };
    },
    created() {
        if (this.authUser && this.authUser.credit_score) {
            this.$store.dispatch("GET_CS_OFFERS");
        }
        if (this.authUser && this.authUser.app_rating >= 4) {
            this.$store.dispatch("GET_AGIT_OFFERS");
        }
        this.$store.dispatch("GET_PERSONAL_AND_USER_TERMS_TEXTS");
    },
    computed: {
        authUser() {
            return this.$store.getters.AUTH_USER;
        },
        formValid() {
            this.$validator.validateAll();
            return Object.keys(this.fields).every(
                (field) => this.fields[field] && this.fields[field].valid
            );
        },
    },
    methods: {},
};
</script>

<style>
.v-btn__content {
    max-width: inherit !important;
    white-space: break-spaces !important;
}
</style>
